import { PagePending } from "@/components/ui/PagePending";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { custom, fallback, object, optional, pipe, string } from "valibot";

const isMonthString = () => custom<string>(input => (typeof input === "string" ? /^\d{4}-\d{2}$/.test(input) : false));

export const Route = createFileRoute("/supporter/$supporterId/allowance-reports/forecast")({
  pendingComponent: PagePending,
  validateSearch: object({
    currency: fallback(optional(string()), undefined),
    start: fallback(optional(pipe(string(), isMonthString())), undefined),
    end: fallback(optional(pipe(string(), isMonthString())), undefined),
  }),
  component: lazyRouteComponent(() => import("./+Forecast")),
});
